module.exports = __webpack_public_path__ + "media/images/gateway/alfacoins-2c12084947a90f2e73aadd5ce9c2b636.jpg";